export const MOCKUPS = {
  login: "/mockups/login.png",
  shopRegistration: "/mockups/shop-registration.png",
  branchRegistration: "/mockups/branch-registration.png",
  sales: "/mockups/sales.png",
  dashboard: "/mockups/dashboard.png",
  inventory: "/mockups/inventory.png",
  salesHistory: "/mockups/sales-history.png",
  profitCalculator: "/mockups/profit-calculator.png",
  debtTracker: "/mockups/debt-tracker.png",
  shopAssistant: "/mockups/shop-assistant.png",
  staffAccess: "/mockups/staff-access.png",
  businessTips: "/mockups/business-tips.png",

  // Backward-compatible aliases for older sections.
  sell: "/mockups/sales.png",
  more: "/mockups/staff-access.png",
};

export const MOCKUP_SCREEN_ORDER = [
  { key: "login", label: "Login", src: MOCKUPS.login },
  { key: "shop-registration", label: "Shop registration", src: MOCKUPS.shopRegistration },
  { key: "branch-registration", label: "Branch registration", src: MOCKUPS.branchRegistration },
  { key: "sales", label: "Sales page", src: MOCKUPS.sales },
  { key: "dashboard", label: "Dashboard", src: MOCKUPS.dashboard },
  { key: "inventory", label: "Inventory", src: MOCKUPS.inventory },
  { key: "sales-history", label: "Sales history", src: MOCKUPS.salesHistory },
  { key: "profit-calculator", label: "Profit calculator", src: MOCKUPS.profitCalculator },
  { key: "debt-tracker", label: "Debt tracker", src: MOCKUPS.debtTracker },
  { key: "shop-assistant", label: "Shop Assistant", src: MOCKUPS.shopAssistant },
  { key: "staff-access", label: "Staff access", src: MOCKUPS.staffAccess },
  { key: "business-tips", label: "Business tips", src: MOCKUPS.businessTips },
];
